/**
 * Logica condivisa dalle due sotto-pagine della Scuola di Armando
 * (Filosofia Creativa e DNA artistico): la hero con video dei progetti,
 * animazioni di entrata dei testi, toggle "Leggi di più" della biografia e
 * scheda della mostra a schermo intero aperta dal "+" della tabella, con lo
 * slider delle immagini che scorre da una mostra all'altra.
 * Il lightbox video è già gestito da `common.js` tramite `.js-video-lightbox`.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import Swiper from 'swiper';
import { Keyboard, Mousewheel, Navigation } from 'swiper/modules';
import 'swiper/css';

import initSchoolAnimations from '../util/schoolAnimations';
import initProjectHeroAnimation from '../util/projectHeroAnimation';

export default function initSchoolSubPage() {
	initSchoolAnimations();
	initProjectHeroAnimation();

	jQuery(document).ready(function ($) {
		// Toggle "Leggi di più": l'altezza viene animata, il troncamento
		// (line-clamp) resta sospeso per tutta la durata così il testo non
		// salta a metà transizione.
		$('.js-bio-toggle').on('click', function (e) {
			e.preventDefault();

			var $button = $(this),
				$text = $button.siblings('.js-bio-text'),
				el = $text[0];

			if (!el) {
				return;
			}

			var open = !$text.hasClass('is-open'),
				from = el.offsetHeight;

			$text.toggleClass('is-open', open);

			var to = el.offsetHeight;

			$text.addClass('is-open');

			gsap.fromTo(
				el,
				{ height: from, overflow: 'hidden' },
				{
					height: to,
					duration: 0.7,
					ease: 'power3.inOut',
					onComplete: function () {
						$text.toggleClass('is-open', open);
						gsap.set(el, { clearProps: 'height,overflow' });
						ScrollTrigger.refresh();
					},
				}
			);

			$button.text(
				open
					? $button.data('label-less')
					: $button.data('label-more')
			);
		});

		// Scheda della mostra: il "+" di ogni riga apre il pannello a schermo
		// intero con le immagini a sinistra (sotto, su mobile) e i testi a destra.
		var $modal = $('.js-mostra-modal');

		if (!$modal.length) {
			return;
		}

		// `#smooth-content` ha una transform (ScrollSmoother) e farebbe da
		// contenitore al position:fixed del modale: va spostato sul body.
		$modal.appendTo('body');

		var $scroller = $modal.find('.js-mostra-scroller'),
			$textColumn = $modal.find('.js-mostra-texts'),
			$texts = $modal.find('.js-mostra-text'),
			sliderEl = $modal.find('.js-mostra-swiper')[0],
			reduceMotion = window.matchMedia(
				'(prefers-reduced-motion: reduce)'
			).matches,
			swiper = null,
			currentIndex = null,
			$lastTrigger = null;

		function pauseScroll(paused) {
			var smoother = ScrollSmoother.get && ScrollSmoother.get();

			if (smoother) {
				smoother.paused(paused);
			}

			$('body').toggleClass('overflow-hidden', paused);
		}

		// Ricevono l'istanza perché Swiper emette slideChange già dentro il
		// costruttore (con initialSlide), quando `swiper` è ancora null.
		function mostraOfSlide(instance) {
			return parseInt(
				instance.slides[instance.activeIndex].getAttribute(
					'data-mostra-index'
				),
				10
			);
		}

		function firstSlideOf(index) {
			var slides = sliderEl.querySelectorAll('.swiper-slide');

			for (var i = 0; i < slides.length; i++) {
				if (parseInt(slides[i].getAttribute('data-mostra-index'), 10) === index) {
					return i;
				}
			}

			return 0;
		}

		// Le immagini sono lazy e le slide fuori vista non entrano mai nel
		// viewport: le vicine vanno chieste prima, o comparirebbero a metà
		// transizione.
		function preloadAround(instance) {
			var current = instance.activeIndex;

			[current - 1, current + 1].forEach(function (i) {
				var slide = instance.slides[i],
					img = slide && slide.querySelector('img');

				if (img) {
					img.loading = 'eager';
				}
			});
		}

		// Il 56 del Figma, su mobile, non basta alle parole più lunghe
		// ("Contemporanea" supera la colonna e andrebbe spezzata a metà): solo
		// quei titoli scendono quanto serve a tenerle intere.
		var measure = document.createElement('canvas').getContext('2d');

		function fitTitle($text) {
			var title = $text.find('.at_school_modal_title')[0];

			if (!title) {
				return;
			}

			title.style.fontSize = '';

			var style = window.getComputedStyle(title),
				widest = 0;

			measure.font = [
				style.fontStyle,
				style.fontWeight,
				style.fontSize,
				style.fontFamily,
			].join(' ');

			title.textContent.split(/\s+/).forEach(function (word) {
				widest = Math.max(widest, measure.measureText(word).width);
			});

			if (widest > title.clientWidth) {
				title.style.fontSize =
					Math.floor(
						(parseFloat(style.fontSize) * title.clientWidth) / widest
					) + 'px';
			}
		}

		// Mostra il testo della mostra `index`. Su mobile testo e immagini
		// scorrono insieme e il testo sta sopra: cambiando altezza sposterebbe
		// lo slider da sotto il dito, quindi lo scroll compensa la differenza.
		function showText(index, animate) {
			if (index === currentIndex) {
				return;
			}

			currentIndex = index;

			var before = sliderEl.getBoundingClientRect().top,
				$active = $texts.filter(function () {
					return $(this).data('mostra-index') === index;
				});

			$texts.not($active).addClass('hidden').removeClass('flex');
			$active.removeClass('hidden').addClass('flex');
			fitTitle($active);

			$scroller[0].scrollTop += sliderEl.getBoundingClientRect().top - before;
			$textColumn[0].scrollTop = 0;

			if (animate && $active.length) {
				gsap.fromTo(
					$active[0],
					{ autoAlpha: 0, y: 20 },
					{
						autoAlpha: 1,
						y: 0,
						duration: 0.6,
						ease: 'expo.out',
						clearProps: 'transform',
					}
				);
			}
		}

		// Va creato a scheda visibile, o Swiper misurerebbe slide di 0px.
		// Orizzontale su mobile (Figma 4385:5933), verticale da md come la
		// colonna di immagini del desktop (Figma 4182:5614).
		function createSwiper(initialSlide) {
			swiper = new Swiper(sliderEl, {
				modules: [Keyboard, Mousewheel, Navigation],
				initialSlide: initialSlide,
				slidesPerView: 1,
				spaceBetween: 40,
				speed: reduceMotion ? 0 : 700,
				navigation: {
					prevEl: $modal.find('.js-mostra-prev')[0],
					nextEl: $modal.find('.js-mostra-next')[0],
				},
				// Acceso solo a scheda aperta, vedi openModal/closeModal.
				keyboard: { enabled: false },
				mousewheel: { forceToAxis: true, thresholdDelta: 10 },
				breakpoints: {
					768: { direction: 'vertical', spaceBetween: 0 },
				},
				on: {
					slideChange: function () {
						showText(mostraOfSlide(this), true);
						preloadAround(this);
					},
				},
			});

			preloadAround(swiper);
		}

		function openModal($trigger) {
			var index = $trigger.data('mostra-index'),
				slide = firstSlideOf(index);

			$lastTrigger = $trigger;

			$modal.removeClass('hidden').attr('aria-hidden', 'false');
			pauseScroll(true);

			// Prima il testo, poi lo slide: così lo slideChange trova la mostra
			// già al suo posto e non rifà l'animazione di cambio. La scheda
			// riparte dall'alto dopo, perché showText compensa lo scroll.
			showText(index, false);
			$scroller[0].scrollTop = 0;

			if (swiper) {
				swiper.update();
				swiper.slideTo(slide, 0);
			} else {
				createSwiper(slide);
			}

			swiper.keyboard.enable();

			gsap.fromTo(
				$modal[0],
				{ autoAlpha: 0 },
				{ autoAlpha: 1, duration: 0.35, ease: 'power2.out' }
			);
			gsap.fromTo(
				[$texts.filter('.flex')[0], sliderEl],
				{ autoAlpha: 0, y: 28 },
				{
					autoAlpha: 1,
					y: 0,
					duration: 0.7,
					ease: 'expo.out',
					stagger: 0.08,
					clearProps: 'transform',
				}
			);

			$modal.find('.js-mostra-modal-close').trigger('focus');
		}

		function closeModal() {
			if (swiper) {
				swiper.keyboard.disable();
			}

			gsap.to($modal[0], {
				autoAlpha: 0,
				duration: 0.3,
				ease: 'power2.in',
				onComplete: function () {
					$modal.addClass('hidden').attr('aria-hidden', 'true');
					gsap.set($modal[0], { clearProps: 'opacity,visibility' });
					$texts.addClass('hidden').removeClass('flex');
					currentIndex = null;
				},
			});

			pauseScroll(false);

			if ($lastTrigger) {
				$lastTrigger.trigger('focus');
				$lastTrigger = null;
			}
		}

		$(document).on('click', '.js-mostra-toggle', function (e) {
			e.preventDefault();
			openModal($(this));
		});

		// Chiusura: click sullo sfondo o sulla X
		$modal.on('click', function (e) {
			if (
				e.target === this ||
				$(e.target).closest('.js-mostra-modal-close').length
			) {
				closeModal();
			}
		});

		$(document).on('keyup', function (e) {
			if (e.key === 'Escape' && !$modal.hasClass('hidden')) {
				closeModal();
			}
		});

		$(window).on('resize', function () {
			if (!$modal.hasClass('hidden')) {
				fitTitle($texts.filter('.flex'));
			}
		});
	});
}
